<template>
  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>
        <div class="intro-services">
          <div class="intro__text text-intro intro-services__text">
            <h1 class="text-intro__title">{{service.name}}</h1>
            <p class="text-intro__subtitle intro-service-text" v-if="service.cf[363]">{{service.cf[363]}}</p>
            <a class="intro__link" v-if="service.cf[366]" @click="$root.requestModal = 1, $root.modalText = '<iframe src=\''+service.cf[366]+'\'></iframe>'">
              <picture><source srcset="/static/img/intro/play.svg" type="image/webp"><img src="/static/img/intro/play.svg" alt="" /></picture>
              <span>Как это происходит?</span>
            </a>
          </div>
          <div class="intro-services__info info-services" v-if="service.cf[364] || service.cf[365]">
            <h2 class="info-services__title">Как это работает</h2>
            <div class="info-services__subtitle" v-if="service.cf[364]">{{service.cf[364]}}></div>
            <ul class="info-services__list" v-if="service.cf[365]">
              <li class="info-services__link" v-if="cf" v-for="(cf, i) in service.cf[365].replace(/-/g, '<span>-</span>').split('\n')" :key="i" v-html="cf"></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="court" v-if="service.cf[367] || service.cf[368] || service.cf[369] || service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
      <div class='container'>
        <div class="court__wrapper">
          <div class="court__inner inner-court">
            <div class="inner-court__text">
              <span class="inner-court__info" v-if="service.cf[367]">{{service.cf[367]}}</span>
              <h1 class="inner-court__title" v-if="service.cf[368]">{{service.cf[368]}}</h1>
              <p class="inner-court__subtitle" v-if="service.cf[369]">{{service.cf[369]}}</p>
              <ul class="inner-court__list" v-if="service.cf[370] || service.cf[371] || service.cf[372] || service.cf[373] || service.cf[374]">
                <li class="inner-court__link" v-if="service.cf[370]">
                  <div class="inner-court__figure">
                    <span>1</span>
                  </div>
                  {{service.cf[370]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[371]">
                  <div class="inner-court__figure">
                    <span>2</span>
                  </div>
                  {{service.cf[371]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[372]">
                  <div class="inner-court__figure">
                    <span>3</span>
                  </div>
                  {{service.cf[372]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[373]">
                  <div class="inner-court__figure">
                    <span>4</span>
                  </div>
                  {{service.cf[373]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[374]">
                  <div class="inner-court__figure">
                    <span>5</span>
                  </div>
                  {{service.cf[374]}}
                </li>
              </ul>
            </div>
            <div class="court__pic">
              <picture v-if="service.id === 614"><source srcset="/static/img/img3.jpg"><img src="/static/img/img3.jpg" alt="" /></picture>
              <picture v-if="service.id === 583"><source srcset="/static/img/img2.jpg"><img src="/static/img/img2.jpg" alt="" /></picture>
              <picture v-else><source srcset="/static/img/img1.png"><img src="/static/img/img1.png" alt="" /></picture>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="cards">
      <div class='container'>
        <div class="cards__wrapper">
          <h2 class="cards__title" id="ya1">Не нужны дорогостоящие юристы</h2>
          <div class="cards__box box-cards">
            <div class="cards-container">
              <!-- Additional required wrapper -->
              <div class="cards-wrapper">
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[375]">{{service.cf[375]}}</h4>
                      <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[376]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[376].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <li v-else>10 комплектов документов, с шаблонами которых наши клиенты уже выигрывали дела</li>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[377]">{{service.cf[377]}}</p>
                      <p class="box-item__text" v-else>Это популярный тариф – вам нужно потратить пару часов и действовать по нашей рекомендации</p>
                      <div class="box-item__footer">
                        <span class="box-item__price" v-if="service.cf[378]">{{service.cf[378]}} руб</span>
                        <span class="box-item__price" v-else>299 руб</span>
                        <div class="box-item__footer-wrapper">
                          <button class="box-item__btn" @click="selectPrice((service.cf[375]?service.cf[375]:'Выиграю дело сам'),(service.cf[378]?service.cf[378]:299),1)"><span>Выбрать</span></button>
                        </div>
                      </div>
                  </div>
                  </div>
                </div>
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[379]">{{service.cf[379]}}</h4>
                      <h4 class="box-item__header" v-else>Подскажите как</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[380]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[380].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <slot v-else>
                          <li>10 комплектов документов</li>
                          <li>Видеоразбор и урок по возврату ав в Вашей ситуации</li>
                          <li>Персональный разбор Вашего дела</li>
                        </slot>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[381]">{{service.cf[381]}}</p>
                      <p class="box-item__text" v-else>
                        Самый популярный тариф. Вы разберетесь во всем сами и без труда решите свой вопрос</p>
                    </div>
                    <div class="box-item__footer">
                      <span class="box-item__price" v-if="service.cf[382]">{{service.cf[382]}} руб</span>
                      <span class="box-item__price" v-else>789 руб</span>
                      <div class="box-item__footer-wrapper">
                        <button class="box-item__btn" @click="selectPrice((service.cf[379]?service.cf[379]:'Подскажите как'),(service.cf[382]?service.cf[382]:499),1)"><span>Выбрать</span></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[383]">{{service.cf[383]}}</h4>
                      <h4 class="box-item__header" v-else>Дайте все готовое</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[384]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[384].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <slot v-else>
                          <li>1 час видеоконсультации с юристом</li>
                          <li>Персональный разбор Вашего дела</li>
                          <li>Юрист подготовит и сделает всё сам</li>
                          <li>Что то четвертое</li>
                        </slot>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[385]">{{service.cf[385]}}</p>
                      <p class="box-item__text" v-else>
                        Премиум-тариф – специалист все сделает за вас, напомнит о нужных действиях и будет всегда на связи</p>
                    </div>
                    <div class="box-item__footer">
                      <span class="box-item__price" v-if="service.cf[386]">{{service.cf[386]}} руб</span>
                      <span class="box-item__price" v-else>2499 руб</span>
                      <div class="box-item__footer-wrapper">
                        <button class="box-item__btn" @click="selectPrice((service.cf[383]?service.cf[383]:'Дайте все готовое'),(service.cf[386]?service.cf[386]:2499),1)"><span>Выбрать</span></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="for-whom__head">
      <div class="for-whom__head-icon"></div>
      <div class="for-whom__head-title">Хочу получить ходатайства бесплатно</div>
      <div class="for-whom__head-email">
        <input autocomplete="off" type="email" name="form[]" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
        <button @click="sendQuestion('ходатайства')"><span>Получить</span></button>
      </div>
    </div>

    <section class="history" v-if="service.cf[387] || service.cf[388] || service.cf[389] || service.cf[390] || service.cf[391] || service.cf[392] || service.cf[401] || service.cf[402]">
      <div class='container'>
        <div class="history__wrapper">
          <h1 class="history__title">Истории выигранных дел</h1>
          <div class="history__inner">
            <div class="history__items">
              <div class="history__item" v-if="service.cf[387] || service.cf[388]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[387]">{{service.cf[387]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[388]">{{service.cf[388]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="service.cf[389] || service.cf[390]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[389]">{{service.cf[389]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[390]">{{service.cf[390]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="service.cf[391] || service.cf[392]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[391]">{{service.cf[391]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[392]">{{service.cf[392]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="showAll">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[401]">{{service.cf[401]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[402]">{{service.cf[402]}}</p>
                </div>
              </div>
              <div class="history__btn-wrapper" v-if="!showAll && (service.cf[401] || service.cf[402])">
                <button class="history__btn" @click="showAll = true">Читать ещё</button>
              </div>
            </div>

            <div class="history__slider">
              <div class="history-container" data-mobile="false">

                <div class="history-wrapper">
                  <div class="history-slide" v-if="service.cf[387] || service.cf[388]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[387]">{{service.cf[387]}}</div>

                      </div>
                      <div class="item-history__body" v-if="service.cf[388]">{{service.cf[388]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[389] || service.cf[390]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[389]">{{service.cf[389]}}</div>

                      </div>
                      <div class="item-history__body" v-if="service.cf[390]">{{service.cf[390]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[391] || service.cf[392]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[391]">{{service.cf[391]}}</div>
                      </div>
                      <div class="item-history__body" v-if="service.cf[392]">{{service.cf[392]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[401] || service.cf[402]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[401]">{{service.cf[401]}}</div>
                      </div>
                      <div class="item-history__body" v-if="service.cf[402]">{{service.cf[402]}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="for">
      <div class='container'>
        <div class="for__warpper">
          <h1 class="for__title title-for">Для кого</h1>
          <div class="for__inner">
            <div class="document__list list-document">
              <ul class="list-document__ul">
                <li v-if="service.cf[393]" class="list-document__link">{{service.cf[393]}}</li><li v-else class="list-document__link">Для тех, кому суд еще не назначили</li>
                <li v-if="service.cf[394]" class="list-document__link">{{service.cf[394]}}</li><li v-else class="list-document__link">Для тех, кому суд уже назначили и времени мало</li>
                <li v-if="service.cf[395]" class="list-document__link">{{service.cf[395]}}</li><li v-else class="list-document__link">Для тех, у кого суд был проигран, права сданы</li>
                <li v-if="service.cf[396]" class="list-document__link">{{service.cf[396]}}</li><li v-else class="list-document__link">Для тех, у кого суд был проигран, права не сданы</li>
                <li v-if="service.cf[397]" class="list-document__link">{{service.cf[397]}}</li>
              </ul>
            </div>
            <div class="for__btn-wrapper">
              <a class="for__btn scroll-to" href="#ya1" >Буду действовать</a>
              <!-- @click="selectPrice('Выиграю дело сам', 0,1)" -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="popup popup-reg is-active" v-if="text">
      <div class="popup__wrapper">
        <div class="popup__inner">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" type="button" @click="text=null, price=null"></button>
            <h4 class="popup__title">{{text}}</h4>
            <span class="popup__price" v-if="price">{{price}} руб</span>
            <div class="form">
              <div class="form-popup">
                <div class="popup-line" v-if="group.name">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{group.name}}</span></div>
                </div>
                <div class="popup-line" v-if="service.cf[403]">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{service.cf[403]}}</span></div>
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Город" class="input input__name" v-model="city" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Имя" class="input input__name" v-model="name" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Телефон" class="input input__tel" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="E-mail" class="input input__email" v-model="email" data-inputmask="'alias': 'email'"/>
                </div>
                <div class="popup-send-btn-wrapper">
                  <button class="popup-send-btn" @click="sendQuestion">Получить документы по моему делу</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>

</template>

<script>
  import axios from '@/router/http'
  import Inputmask from 'inputmask'
  import $ from 'jquery'
  export default {
    name: 'service',
    data () {
      return {
        service: {
          cf: {}
        },
        group: { cf: {} },
        showAll: false,
        text: null,
        name: null,
        price: null,
        email: null,
        phone: null,
        city: null,
        urist: null
      }
    },
    methods: {
      initPage () {
        axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.service = response.data
          if (!this.service.cf) this.service.cf = {}
          if (this.service.cf[341]) {
            axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.service.cf[341]).then(response => {
              this.group = response.data
              if (!this.group.cf) this.group.cf = {}
            })
          }
          setTimeout(() => {
            // eslint-disable-next-line
            new Swiper('.cards-container', {
              observer: true,
              wrapperClass: 'cards-wrapper',
              slideClass: 'cards-slide',
              observeParents: true,
              slidesPerView: 3,
              spaceBetween: 0,
              speed: 800,
              breakpoints: {
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: 0
                },
                376: {
                  slidesPerView: 1
                },
                728: {
                  slidesPerView: 2
                },
                767: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1292: {
                  slidesPerView: 3
                }
              }
            })
            // eslint-disable-next-line
            new Swiper('.history-container', {
              wrapperClass: 'history-wrapper',
              slideClass: 'history-slide',
              loop: true,
              observer: true,
              observeParents: true,
              slidesPerView: 3,
              spaceBetween: 0,
              speed: 800,
              breakpoints: {
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: -5
                },
                376: {
                  slidesPerView: 1
                },
                728: {
                  slidesPerView: 2
                },
                767: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1292: {
                  slidesPerView: 3
                }
              }
            })
          }, 1000)
        })
        var self = this
        $(document).mouseup(function (e) {
          var container = $('.popup__content')
          if (container.has(e.target).length === 0) {
            self.text = null
          }
        })
      },
      selectPrice (name, price, urist) {
        this.text = name
        this.price = price
        this.urist = urist
        Inputmask().mask(document.querySelectorAll('input'))
        setTimeout(() => {
          Inputmask().mask(document.querySelectorAll('input'))
        }, 1000)
      },
      sendQuestion (element) {
        if (element === 'ходатайства') {
          var formDataHodataistva = new FormData()
          formDataHodataistva.append('crm', '16')
          formDataHodataistva.append('pipe', '34')
          formDataHodataistva.append('contact[name]', 'Заявка "Получить ходатайства"')
          formDataHodataistva.append('contact[467]', this.email)
          formDataHodataistva.append('lead[468]', 'Ходатайства в суд и не только')
          formDataHodataistva.append('lead[469]', 'Ходатайства в суд и не только')
          return axios.post('https://bez.v-avtoservice.com/api/import-lead',
            formDataHodataistva,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            alert('Спасибо, ваша заявка отправлена')
          })
        }
        if (!this.email) alert('Вам необходимо указать E-mail')
        else {
          if (this.urist) {
            setTimeout(() => {
              var formData = new FormData()
              formData.append('crm', '11')
              formData.append('pipe', '22')
              formData.append('contact[name]', this.name)
              formData.append('contact[199]', this.phone)
              formData.append('contact[200]', this.email)
              formData.append('contact[207]', this.city)
              formData.append('lead[price]', this.price)
              formData.append('lead[204]', this.city)
              formData.append('lead[214]', 'avtourist.net')
              formData.append('note', 'Группа: ' + this.group.name + '<br> Услуга: ' + this.service.name)

              axios.post('https://urist.v-avtoservice.com/api/import-lead',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(res => {
            setTimeout(() => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            }, 1000)
          })
              axios.post('https://urist1.v-avtoservice.com/api/import-lead',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(res => {
            setTimeout(() => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            }, 1000)
          })
            }, 1)
          }
          var formData = new FormData()
          formData.append('crm', '9')
          formData.append('pipe', '17')
          formData.append('contact[name]', this.name)
          formData.append('contact[141]', this.phone)
          formData.append('contact[142]', this.email)
          formData.append('contact[143]', this.city)
          formData.append('lead[price]', this.price)
          formData.append('lead[147]', this.city)
          formData.append('lead[146]', this.group.name)
          formData.append('lead[145]', this.service.name)
          axios.post('https://urist1.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            console.log(res.data)
            if (res.data.link.result.payment_link) {
              window.location.href = res.data.link.result.payment_link
            } else if (res.data.link.result.error) {
              console.log(res.data.link.result.error_message)
              alert('ошибка, попробуйте позже')
            } else alert('Спасибо, ваша заявка отправлена')
          })
        }
      }
    },
    mounted () {
      this.initPage()
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>
 .popup-line .nice-select::after {
   display: none;
 }
</style>



// WEBPACK FOOTER //
// src/components/service.vue